import { render, staticRenderFns } from "./MessageEmpty.vue?vue&type=template&id=774c9556"
import script from "./MessageEmpty.vue?vue&type=script&lang=js"
export * from "./MessageEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports